export default "/images/vendor/pannellum-react/es/pannellum/css/sprites.svg?c08944fed399e84633d0829846d52b50";